/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
  }
  onChange(event) {
    
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    let removes = this.container.querySelectorAll('.remove');
    let removesCustom = this.container.querySelectorAll('.deleteItem');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
     removesCustom.forEach((removeCustom) => {
      removeCustom.addEventListener('click', (event) => {

        event.preventDefault();
         //custom build - multiple items
        
          var groupKey = event.currentTarget.getAttribute('data-groupkey');
          var dataLine = event.currentTarget.getAttribute('data-line');
       
          // Get all elements with the data attribute "groupkey"
          const elementsWithGroupKey = document.querySelectorAll('[data-groupkey]');

          // Initialize an empty object to store the JSON data
          var jsonData = {};

          var productIds = [];
          var quantities = [];
          // Loop through each element
          for (let i = 0; i < elementsWithGroupKey.length; i++) {
        	const element = elementsWithGroupKey[i];

        	// Get the value of the data attribute "groupkey"
        	const groupKeyCheck = element.getAttribute('data-groupkey');
        	const groupKeyLine = element.getAttribute('data-line');
        	const productKey = element.getAttribute('data-key');
            	if (groupKeyCheck === groupKey) {
        		// Use a for loop to create the key-value pairs with a value of 0
        		productIds.push(productKey.toString());
        		quantities.push(0);
            	}
        }

        // Create an empty object for updates
        var updates = {};

        // Loop through the arrays and populate the updates object
        for (var i = 0; i < productIds.length; i++) {
        	var productId = productIds[i];
        	var quantity = quantities[i];
        	updates[productId] = quantity;
            }

        // Create the data object for your POST request
        var postData = {
        	updates: updates,
        	sections: "main-cart,cart-bubble"
          };

      // Print the JSON data
      
      this.updateQuantityCustom(dataLine, postData, '0');
      });
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {

    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
   
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, line);

        this.container.classList.remove('cart-disabled');

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        //logic to refresh cart when removing free products
        const hasRangefinder = parsedState.items.some(item => item.id === 44378471006394);
        const hasGiftCard = parsedState.items.some(item => item.id === 44378495353018);
  if (hasRangefinder && hasGiftCard){
    var delayTime = 3600;
  } else if (hasRangefinder || hasGiftCard) {
    var delayTime = 1700;
  } else {
    var delayTime = 10;
  }
       setTimeout(function() {
  window.location.href = "/cart";
   },delayTime);
      });
  }
  updateQuantityCustom(line, lines, quantity) {

   this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }
dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });

            // Send the POST request using jQuery
$.ajax({
  url: window.Shopify.routes.root + 'cart/update.js',
  type: 'POST',
  data: JSON.stringify(lines), // Convert the data to JSON string
  contentType: 'application/json', // Set the content type to JSON
  dataType: 'json', // Set the expected response data type to JSON
  success: function(response) {
    // Handle the JSON response here
  }
})
.then((state) => {

  
  
        const parsedState = state;
dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, line);

        this.container.classList.remove('cart-disabled');

  //logic to refresh cart when removing free products
        const hasRangefinder = parsedState.items.some(item => item.id === 44378471006394);
        const hasGiftCard = parsedState.items.some(item => item.id === 44378495353018);
  if (hasRangefinder && hasGiftCard){
    var delayTime = 3600;
  } else if (hasRangefinder || hasGiftCard) {
    var delayTime = 1700;
  } else {
    var delayTime = 10;
  }
   setTimeout(function() {
  window.location.href = "/cart";
   },delayTime);

  
      });

  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function(e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  renderContents(parsedState, line) {

    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      let removes = this.container.querySelectorAll('.remove');

      if (removes) {
        removes.forEach((remove) => {
          remove.addEventListener('click', (event) => {

            this.updateQuantity(event.target.dataset.index, '0');

            event.preventDefault();
          });
        });
      }
      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
    }));
  }
          
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});

